import {
  Checkbox,
  Form,
  Input,
  Radio,
  Space,
  Typography,
  Flex,
} from "antd";
import { QuestionType } from "../../types/survey";
import classes from "./question.module.css";
import useQuestion from "./useQuestion";

const {
  Paragraph,
  Title
} = Typography;

const {
  TextArea
} = Input;

interface QuestionItemType {
  item: QuestionType;
  isVisible: boolean;
}

const Question = (props: QuestionItemType) => {
  const { item, isVisible } = props;
  const {
    fieldDisabled,
    titleLevel,
    handleCheckbox,
    itemOptions,
    timeSlots,
    isTimeSlots,
  } = useQuestion({ item });

  return (
    <Flex vertical gap={16} align="center">
      {isVisible ? (
        <Space
          direction="vertical"
          align="center"
          size={0}
          style={{ maxWidth: 826, width: "100%", textAlign: "center" }}
        >
          <Title level={titleLevel} style={{ marginBottom: 0 }}>
            {item.content}
          </Title>
          <Paragraph style={{ marginBottom: 0 }}>
            {item.title}
          </Paragraph>
        </Space>
      ) : null}
      <Flex justify="center" className={classes.field}>
        {item.nullable_answer
          ? (
            <Form.Item hidden={!isVisible} style={{ marginBottom: 0 }}>
              <Checkbox
                checked={fieldDisabled}
                onChange={handleCheckbox}
              >
                {item.nullable_answer_text}
              </Checkbox>
            </Form.Item>
          )
          : null}
        <Form.Item
          name={item.id}
          hidden={!isVisible}
          noStyle
        >
          {item.type.name === "textarea" ? <TextArea disabled={fieldDisabled} /> : null}
          {item.type.name === "text" ? <Input disabled={fieldDisabled} /> : null}
          {item.type.name === "boolean" ? (
            <Radio.Group
              disabled={fieldDisabled}
              optionType="button"
              buttonStyle="solid"
            >
              <Radio value>Si</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          ) : null}
          {item.type.name === "radio" ? (
            <Radio.Group
              disabled={fieldDisabled}
              optionType="button"
              buttonStyle="solid"
              size={isTimeSlots ? "large" : "middle"}
            >
              <Space direction="vertical" style={{ width: "100%" }}>
                {itemOptions ? itemOptions.map(
                  (radioItem: string) => (
                    <Radio
                      key={radioItem}
                      value={radioItem}
                    >
                      {isTimeSlots
                        ? (
                          <span className={classes.dayTime}>
                            <b>{radioItem}</b> {timeSlots[radioItem]}
                          </span>
                        )
                        : radioItem}
                    </Radio>
                  )
                ) : null}
              </Space>
            </Radio.Group>
          ) : null}
          {item.type.name === "checkbox" ? (
            <Checkbox.Group disabled={fieldDisabled}>
              {itemOptions ? itemOptions.map(
                (radioItem: string) => {
                  return <Checkbox key={radioItem} value={radioItem}>{radioItem}</Checkbox>;
                }
              ) : null}
            </Checkbox.Group>
          ) : null}
        </Form.Item>
      </Flex>
    </Flex>
  );
};

export default Question;
